import { render, staticRenderFns } from "./billing.vue?vue&type=template&id=8793c500"
import script from "@/scripts/gpuHub/billing/billing.js?vue&type=script&lang=js&external"
export * from "@/scripts/gpuHub/billing/billing.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports